import { filterPage } from "components/common/Filters/FiltersHelper";
import { hasTemplatePlansAccess } from "utils/StoreUtils";
import { tabs } from "./CorpViewHelper";
import PlansData from "./PlansData";
import PropertiesData from "./PropertiesData";

export const tabDetails = (view: string, selectedListType: string, selectedList: any) => {
  const details = [
    {
      label: tabs.properties,
      content: Hoc(PropertiesData, view, selectedListType, selectedList),
      filtersToClear: [filterPage.listDisplay, filterPage.dashboardDisplay, filterPage.consultantListDisplay]
    },
    {
      label: tabs.library_plans,
      content: Hoc(PlansData, view, selectedListType, selectedList),
      filtersToClear: [filterPage.listDisplay, filterPage.dashboardDisplay, filterPage.consultantListDisplay]
    }
  ];
  if (selectedListType === "default" && hasTemplatePlansAccess()) {
    details.push({
      label: tabs.template_plans,
      content: Hoc(PlansData, view, selectedListType, selectedList),
      filtersToClear: [filterPage.listDisplay, filterPage.dashboardDisplay, filterPage.consultantListDisplay]
    });
  }
  return details;
};

function Hoc(WrappedComponent: any, view: string, selectedListType: string, selectedList: any) {
  return function () {
    return <WrappedComponent view={view} selectedListType={selectedListType} selectedList={selectedList} />;
  };
}
